export default "__VITE_ASSET__iXdFRHrt__"